import { RealEstateCategory, SegmentationType, TransactionType } from '../../@types/types'
import { API_ENDPOINT } from '../../config'

export type ListingCopyTargetSegmentation = {
  segmentation: SegmentationType
  transaction: TransactionType
  category: RealEstateCategory
}

export const createTypeChangedListing = async (
  sourceRealEstateId: string,
  target: ListingCopyTargetSegmentation
): Promise<string> => {
  const response = await window.fetch(
    `${API_ENDPOINT}/anbieten/private-anbieter/inserieren/api/realEstate/type-change/${sourceRealEstateId}`,
    {
      body: JSON.stringify(target),
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
      redirect: 'follow',
    }
  )

  if (!response.ok) {
    throw new Error(`Creating a type-changed listing failed with status ${response.status}`)
  }

  if (!response.url) {
    throw new Error('Creating a type-changed listing did not return a redirect URL')
  }

  return response.url
}
